<div class="container-fluid mt-3 mb-5" *ngIf="survey">

  <div class="dashboard-card shadow-sm">

    <div class="card-header bg-white border-bottom p-4">
      <div class="row align-items-center">
        <div class="col-md-7">
          <h4 class="font-weight-bold text-dark-purple mb-1">{{ 'components.responses.responses' | translate }}</h4>
          <!-- <p class="text-muted mb-4"></p> -->

          <div class="d-flex stats-row">
            <div class="stat-item mr-5">
              <h2 class="mb-0 font-weight-bold text-primary-purple">{{ survey?.members?.length || 0 }}</h2>
              <small class="text-uppercase text-muted font-weight-bold tracking-wide">Total Members</small>
            </div>
            <div class="stat-item mr-5">
              <h2 class="mb-0 font-weight-bold text-success">{{ answersSent?.length }}</h2>
              <small class="text-uppercase text-muted font-weight-bold tracking-wide">Responded</small>
            </div>
          </div>
        </div>

        <div class="col-md-5 d-flex justify-content-end" *ngIf="chartOptions">
          <div class="chart-wrapper w-100" style="height: 200px;">
            <div echarts [options]="chartOptions" style="height: 100%; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body p-4">
      <div class="row justify-content-between align-items-center">
        <ng-container *ngIf="survey?.answers_sent > 0">
          <span class="label-box font-weight-bold">
            {{ survey?.answers_sent }}
            <ng-container *ngIf="survey?.answers_sent == 1">{{ "generic.response" | translate }}</ng-container>
            <ng-container *ngIf="survey?.answers_sent > 1">{{ "generic.responses" | translate }}</ng-container>
          </span>
        </ng-container>
        <ng-container *ngIf="survey?.answers_sent === 0">
          <span>{{ 'pages.surveys.responses.no-responses' | translate }}</span>
        </ng-container>
        <mat-button-toggle-group *ngIf="!survey?.is_revised" [(ngModel)]="survey.status" (ngModelChange)="onChangeStatus($event)" style="height: 38px; align-items: center;">
          <mat-button-toggle
            [value]="'EVALUATING'"
            [ngClass]="{'bg-success': survey.status === 'EVALUATING'}">
            {{ "generic.accept-answers" | translate }}
          </mat-button-toggle>

          <mat-button-toggle
            [value]="'CLOSED'"
            [ngClass]="{'bg-danger': survey.status === 'CLOSED'}">
            {{ "generic.block-answers" | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>

  </div>
</div>

<div class="my-4" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<div class="mt-5" *ngIf="survey?.answers_sent > 0 && questions?.length > 0 && !loading">
  <ng-container *ngIf="tabIndex == 0">
    <div
      *ngFor="let question of questions; let i = index;"
      class="container-fluid accordion-container mt-3 accordion-inner"
    >
      <mat-accordion class="accordion" multi >
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header class="py-2">
            <mat-panel-title>
              <span>{{ question.question }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- <pre>{{ question | json }}</pre> -->
          <div *ngIf="question?.description" class="alert alert-info my-3 mx-3" role="alert">
            <strong>{{ 'generic.description' | translate }}:</strong> {{ question.description }}
          </div>
          <app-single-question-responses [question]="question" [showPrivateInfo]="showPrivateInfo"/>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <mat-paginator
      class="mt-5"
      [length]="totalQuestions"
      [pageSize]="pageSize"
      [pageIndex]="currentPageIndex"
      [pageSizeOptions]="[1, 5, 10]"
      (page)="onPageChange($event)">
    </mat-paginator>
  </ng-container>

  <ng-container *ngIf="tabIndex == 1">

  </ng-container>

  <ng-container *ngIf="tabIndex == 2">

  </ng-container>

</div>

<div class="anonymize-button" *ngIf="survey?.answers_sent > 0 && !survey?.customs?.anonymous_survey" (click)="toggleAnonymousData()">
  <span *ngIf="showPrivateInfo">{{ 'generic.hide-private-data' | translate }}</span>
  <span *ngIf="!showPrivateInfo">{{ 'generic.show-private-data' | translate }}</span>
</div>
